import React from "react"
import PropTypes from "prop-types"
import moment from "moment"


import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"

import {Tr} from "../../../ui/SimpleTable"
import {ACCORDION_ITEMS} from "../../../utils/constants/wizard"
import EditLink from "./EditLink"
import {ParaNoMargin, Td} from "./ui/layout"
import ValidationTooltip from "../../ValidationTooltip/ValidationTooltip"
import FlexWrapper from "../../../ui/Layout/FlexWrapper"

const ERROR_CODES = ["PBSUR_CYCVN0014"]


const DateValidator = ({schedule, backToRoute, ...props}) => {
  const idNamespace = id("DateValidator", props)
  const errors = schedule.validationErrors.filter((error) => ERROR_CODES.includes(error.code))

  return (
    <Tr>
      <Td isFirst isLeft>
        <ParaNoMargin bold> <FormattedMessage id="insights.schedule.validate.date.label" /> </ParaNoMargin>
      </Td>
      <Td isFirst>
        {
          errors.length
            ? <FlexWrapper align="center">
              <EditLink
                id={idNamespace}
                url={backToRoute}
                hash={ACCORDION_ITEMS.frequencyAndTimeframe}
                queryParams={{scheduleId: schedule.id}}
                contentId="insights.schedule.validate.date.errorLabel" />
              <ValidationTooltip errors={errors} />
            </FlexWrapper>
            : <ParaNoMargin id={idNamespace}> {moment(schedule.nextTriggerAt).format("DD/MM/YYYY, HH:mm")} </ParaNoMargin>
        }
      </Td>
    </Tr>
  )
}

DateValidator.propTypes = {
  schedule: PropTypes.object.isRequired,
  backToRoute: PropTypes.string.isRequired
}

export default DateValidator
